// @core/api/endpoints/fiscalization/list_fiscal_receipts.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  ListFiscalReceiptsResponse,
} from '../../../types/fiscalization';
import type { PaginatedRequest } from '../../../types/pagination';

const BASE_PATH = '/fiscalization';

/**
 * List fiscal receipts
 * Returns a paginated list of fiscal receipts with optional filtering by type, status, fiscal point, and date range.
 */
export async function ListFiscalReceipts(
  params?: PaginatedRequest,
  options?: RequestOptions
): Promise<ListFiscalReceiptsResponse> {
  const client = getApiClient();
  const requestPath = `${BASE_PATH}/fiscal-receipts`;
  const requestOptions = options;
  return client.get<ListFiscalReceiptsResponse>(requestPath, { ...requestOptions, params });
}
